<template>
  <div
    class="c-product-info__description"
    aria-role="content"
    aria-label="Product description"
  >
    <wysiwyg
      :html="(more) ? longDescription : shortDescription"
      paragraph-size="small"
    />
    <button
      v-if="longDescription && shortDescription"
      class="t-link t-paragraph"
      :aria-expanded="more ? 'true' : 'false'"
      aria-label="Collapse product description"
      @click="more = !more"
    >
      {{ more ? 'Less' : 'More' }}
    </button>
  </div>
</template>
<script>
import get from 'lodash/get';
import Wysiwyg from '../wysiwyg/Wysiwyg';
export default {
  components: {
    Wysiwyg,
  },
  props: {
    product: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return { more: false }
  },
  computed: {
    shortDescription() {
      const product = this.product
      let openingP = "<p[^>]*>";
      let closingP = "</p>";
      let openingSpan = "<span[^>]*>";
      let closingSpan = "</span>";
      if (product && product.description) {
        // check to see if there are p tags
        if (product.description.match(new RegExp(openingP + "(.*)" + closingP))) {
          // grab the first p tag
          let paragraph = product.description.match(new RegExp(openingP + "(.*)" + closingP))[1];
          // check to see if there is a span tag
          if (paragraph.match(new RegExp(openingSpan + "(.*)" + closingSpan))) {
            // grab the first span tag
            let span = paragraph.match(new RegExp(openingSpan + "(.*)" + closingSpan))[1]
            return span + " ..."
          } else if (paragraph.length > 100) {
            return paragraph + " ..."
          } else {
            return paragraph + " ..."
          }
        } else if (product.description.match(new RegExp(openingSpan + "(.*)" + closingSpan))) {
          return product.description.match(new RegExp(openingSpan + "(.*)" + closingSpan))[0]
        } else if (product.description.match(new RegExp("<b[^>](.*)</b>"))) {
          return product.description.match(new RegExp("<b[^>](.*)</b>"))[0]
        } else {
          // if there are no p tags return null
          // (watcher will set more to true)
          return null
        }
      }
      return null
    },
    longDescription() {
      return get(this.product, 'description')
    }
  },
  watch: {
    shortDescription(value) {
      if (value === null) {
        this.more = true
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.c-product-info__description {
  margin-bottom: rem(5px);
  @include respond(tab-land) {
    margin-bottom: rem(10px);
  }
  .t-link {
    cursor: pointer;
    border: none;
    background-color: none;
    background: none;
  }
}
</style>
